import { JSONSchemaType } from 'ajv'

export interface IBlockReasonFormData {
  code: string
  description: string
  instructionsToSolve: string
  isSolvedByPasswordReset: boolean
}

const BlockReasonSchema: JSONSchemaType<IBlockReasonFormData> = {
  type: 'object',
  properties: {
    code: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    description: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    instructionsToSolve: {
      type: 'string',
    },
    isSolvedByPasswordReset: {
      type: 'boolean',
    },
  },
  required: ['code', 'description'],
  additionalProperties: false,
}

export default BlockReasonSchema
